import {useTranslation} from 'react-i18next';
import {IconSuccess} from '../../components/icons/Icon';
import './ForgotPassword.scss';

const PasswordResetMailSent = () => {
    const [t] = useTranslation();

    return (
        <>
            <div className="icon-success">
                <IconSuccess/>
            </div>

            <h5 className="my-4">{t('forgotPassword.MAIL_SENT')}</h5>

            <div className="explanation">
                {t('forgotPassword.MAIL_SENT_CONFIRMATION')}
            </div>
        </>
    );
};

export default PasswordResetMailSent;
